export type ErrorComponentProps = {
    title: string,
    message: string
}

export function ErrorComponent(props: ErrorComponentProps) {
    return (
      <>
        <main className="grid min-h-full place-items-center bg-primary px-6 py-24 sm:py-32 lg:px-8">
          <div className="text-center">
            {/* <p className="text-base font-semibold text-indigo-600">404</p> */}
            <h1 className="mt-4 text-3xl font-bold tracking-tight text-contrast-primary sm:text-5xl">{props.title}</h1>
            <p className="mt-6 text-base leading-7 text-contrast-tertiary">{props.message}</p>
            <div className="mt-10 flex items-center justify-center gap-x-6">
              <a href="https://discord.gg/mAErry4jUf" target="_blank" className="text-sm font-semibold text-emphasis">
                Report a problem
              </a>
            </div>
          </div>
        </main>
      </>
    )
  }
  